// The login page can be opened as /login?sessionExpired=true&path=<encoded>.
// Returns the in-app path to go back to after login, or null when there is
// none. decodeURIComponent(null) is the *string* "null", which is truthy and
// made navigate("null") resolve to /login/null - so absence must stay null.
export function getRedirectPath(search) {
  const raw = new URLSearchParams(search).get('path');
  if (!raw) return null;

  let path;
  try {
    path = decodeURIComponent(raw);
  } catch (e) {
    return null;
  }

  // Only same-app absolute paths: no relative ("null"), no protocol-relative
  // ("//host") and no full URLs.
  return path.startsWith('/') && !path.startsWith('//') ? path : null;
}
